export default __webpack_public_path__ + "static/s7-36990e6e7eac1441c94a6421d79e2055.svg";